/**
 * GARAN EU guarantee label + legal notice - product page Installation tab.
 *
 * The GARAN app's blocks (the product's durability label and the site-wide legal
 * guarantee notice) are added to the Product Main section in the theme editor and
 * rendered by sections/product-main.liquid into two hidden popups, on EU markets
 * only. The app may inject its artwork after page load, so this polls each popup
 * and reveals its row ("Legal Guarantee Notice", then "GARAN Label") once the
 * popup has artwork. Each row's "View" button opens its popup in Magnific Popup,
 * the same lightbox the product gallery uses.
 *
 * Rows for which the app renders nothing stay hidden. In the theme editor the
 * popups are shown in place (so the blocks can be selected) and both rows are
 * revealed.
 */
jQuery(function ($) {
  var rows = [
    { $row: $('#garan-notice'), $popup: $('#garan-notice-popup') },
    { $row: $('#garan-label-row'), $popup: $('#garan-label-popup') }
  ].filter(function (item) {
    return item.$row.length && item.$popup.length;
  });

  if (!rows.length) {
    return;
  }

  if (window.Shopify && window.Shopify.designMode) {
    $.each(rows, function (i, item) {
      item.$row.css('display', '');
    });
    return;
  }

  var POLL_MS = 250;
  var MAX_WAIT_MS = 15000;
  var ARTWORK_SELECTOR = 'img[src], svg';

  function bindPopup($trigger, $popup) {
    $trigger.on('click', function (event) {
      event.preventDefault();

      if (!$.fn.magnificPopup) {
        var src = $popup.find('img').first().attr('src');
        if (src) {
          window.open(src, '_blank', 'noopener');
        }
        return;
      }

      $.magnificPopup.open({
        items: { src: $popup, type: 'inline' },
        mainClass: 'garan-notice-mfp',
        closeBtnInside: true,
        removalDelay: 0
      });
    });
  }

  function step() {
    var pending = 0;

    $.each(rows, function (i, item) {
      if (item.revealed) {
        return;
      }
      if (item.$popup.find(ARTWORK_SELECTOR).length) {
        item.revealed = true;
        item.$popup.find('img[loading="lazy"]').removeAttr('loading');
        item.$row.css('display', '');
        bindPopup(item.$row.find('.installation-tab__button'), item.$popup);
      } else {
        pending += 1;
      }
    });

    return pending === 0;
  }

  if (step()) {
    return;
  }

  var waited = 0;
  var timer = setInterval(function () {
    waited += POLL_MS;
    if (step() || waited >= MAX_WAIT_MS) {
      clearInterval(timer);
    }
  }, POLL_MS);
});
